export default __webpack_public_path__ + "img/cWRoceDZ.09da44e0.svg";